import type { AxiosError } from 'axios';

interface ApiErrorData {
  success?: boolean;
  error?: { code?: string; message?: string; details?: unknown };
  code?: string;
  message?: string;
}

/**
 * Extracts error code from an Axios error response.
 * Supports both `{ error: { code } }` and `{ code }` formats.
 */
export function getApiErrorCode(error: unknown): string | undefined {
  const axiosError = error as AxiosError<ApiErrorData>;
  const data = axiosError?.response?.data;
  return data?.error?.code || data?.code;
}

/**
 * Checks if an API error is a BUSINESS_* limit exceeded error.
 */
export function isLimitError(error: unknown): boolean {
  const code = getApiErrorCode(error);
  return !!code && code.startsWith('BUSINESS_') && code.includes('LIMIT');
}
